















import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {
  NetworkingStatus,
  NetworkingStatusColor,
  NetworkingStatusDescription,
  NetworkingStatusLabel,
} from '@/model/network/Networking';
import Widget from '@/components/Utils/Widget.vue';
import NetworkNetworkingStore from '@/store/network/NetworkNetworking.store';
import {getModule} from 'vuex-module-decorators';
import StatusDisplayer from '@/components/Utils/StatusDisplayer.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {StatusDisplayer, Widget},
})
export default class NetworkStatusWidget extends Mixins<BaseComponent>(BaseComponent) {

  private networkingStore: NetworkNetworkingStore = getModule(NetworkNetworkingStore, this.$store);

  @Prop({default: true})
  private showLink!: boolean;

  private networkingStatusColor: Map<NetworkingStatus, string> = NetworkingStatusColor;
  private networkingStatusLabel: Map<NetworkingStatus, string> = NetworkingStatusLabel;
  private networkingStatusDescription: Map<NetworkingStatus, string> = NetworkingStatusDescription;

  private async mounted() {
    this.setLoading();
    try {
      await this.networkingStore.fetchStatus();
    } finally {
      this.setLoaded();
    }
  }
}
